<div class="terminal-container">
  <!-- Terminal Header -->
  <div class="terminal-header">
    <div class="terminal-title">
      <div class="terminal-dots">
        <span class="dot red"></span>
        <span class="dot yellow"></span>
        <span class="dot green"></span>
      </div>
      <span class="title-text">Logs</span>
    </div>
    <div class="terminal-controls">
      <span class="log-count"
        >{{ filteredLogs.length }}/{{ totalLogs }} events</span
      >
      <mat-slide-toggle
        [(ngModel)]="liveMode"
        (change)="toggleLiveMode()"
        color="primary">
        <span class="live-label" [class.active]="liveMode">
          <span class="live-indicator" *ngIf="liveMode"></span>
          LIVE
        </span>
      </mat-slide-toggle>
      <button mat-icon-button (click)="loadLogs()" matTooltip="Refresh">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  </div>

  <!-- Toolbar with Search and Filters -->
  <div class="terminal-toolbar">
    <div class="search-container">
      <mat-icon class="search-icon">search</mat-icon>
      <input
        #searchInput
        type="text"
        class="search-input"
        placeholder="Search logs... (press /)"
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearchChange()" />
      <button
        mat-icon-button
        class="clear-search"
        *ngIf="searchQuery"
        (click)="searchQuery = ''; onSearchChange()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div class="filter-chips">
      <button
        *ngFor="let level of logLevels"
        class="filter-chip"
        [ngClass]="level"
        [class.active]="isFilterActive(level)"
        (click)="toggleFilter(level)">
        {{ level | uppercase }}
      </button>
      <button
        class="clear-filters"
        *ngIf="hasActiveFilters()"
        (click)="clearFilters()">
        <mat-icon>filter_alt_off</mat-icon>
        Clear
      </button>
    </div>
  </div>

  <!-- Log Body -->
  <div class="terminal-body" #logContainer>
    <!-- Loading State -->
    <div class="loading-state" *ngIf="loading">
      <mat-spinner diameter="32"></mat-spinner>
      <span>Loading logs...</span>
    </div>

    <!-- Empty State -->
    <div class="empty-state" *ngIf="!loading && filteredLogs.length === 0">
      <mat-icon>inbox</mat-icon>
      <span>No logs found.</span>
    </div>

    <!-- Log Entries -->
    <ng-container *ngIf="!loading && filteredLogs.length > 0">
      <div
        *ngFor="let log of filteredLogs; let i = index; trackBy: trackByLogId"
        class="log-entry"
        [class.expanded]="isExpanded(log.id)">
        <div
          class="log-line"
          [ngClass]="log.level"
          (click)="hasDetails(log.details) && toggleLogExpand(log.id)">
          <span class="line-number">{{ getLineNumber(i) }}</span>
          <span class="log-date">{{ formatDate(log.timestamp) }}</span>
          <span class="log-timestamp">{{
            formatTimestamp(log.timestamp)
          }}</span>
          <span class="log-level" [ngClass]="log.level">{{
            log.level | uppercase
          }}</span>
          <span class="log-action">{{ log.action }}</span>
          <span class="log-resource">&gt;{{ log.resource }}</span>
          <span class="log-user" *ngIf="log.user">[{{ log.user }}]</span>
          <mat-icon class="expand-icon" *ngIf="hasDetails(log.details)">
            {{ isExpanded(log.id) ? 'expand_less' : 'expand_more' }}
          </mat-icon>
          <button
            mat-icon-button
            class="copy-btn"
            (click)="
              copyToClipboard(log.action + ' ' + log.resource);
              $event.stopPropagation()
            "
            matTooltip="Copy">
            <mat-icon>content_copy</mat-icon>
          </button>
        </div>

        <!-- Expanded Details -->
        <div
          class="log-details-expanded"
          *ngIf="isExpanded(log.id) && hasDetails(log.details)">
          <div class="details-header">
            <span>Details</span>
            <button
              mat-icon-button
              (click)="
                copyToClipboard(formatDetailsPretty(log.details!));
                $event.stopPropagation()
              "
              matTooltip="Copy JSON">
              <mat-icon>content_copy</mat-icon>
            </button>
          </div>
          <pre class="details-json">{{
            formatDetailsPretty(log.details!)
          }}</pre>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Terminal Footer -->
  <div class="terminal-footer">
    <span class="status">
      <span class="live-status" *ngIf="liveMode">
        <span class="pulse"></span>
        Live mode - refreshing every 5s
      </span>
      <span *ngIf="!liveMode">Ready</span>
    </span>
    <span class="keyboard-hint">Press <kbd>/</kbd> to search</span>
  </div>
</div>
